import type { Traducao } from '../tipos';

/**
 * Textos do acervo documental da máquina — painel da máquina e filtros do
 * dashboard. Área própria porque o vocabulário é compartilhado entre as duas
 * telas (ver ../README.md).
 */
export const documentos: Traducao = {
  pt: {
    painel: {
      titulo: 'Documentos da máquina',
      subtitulo: 'Acervo documental exigido para o equipamento',
      previa: 'prévia',
      previaExplicacao: 'Módulo em prototipagem: os documentos ficam neste navegador e ainda não sobem para o servidor.',
      adicionar: 'Adicionar documento',
      vazio: 'Nenhum documento neste equipamento ainda.',
      contagem: '{{total}} documento(s)',
    },
    resumo: {
      pendentes: 'Pendentes',
      emAnalise: 'Em análise',
      entregues: 'Entregues',
      atrasados: 'Atrasados',
    },
    coluna: {
      tipo: 'Tipo',
      codigo: 'Código',
      revisao: 'Rev.',
      responsavel: 'Responsável',
      emissao: 'Emissão',
      prazo: 'Prazo',
    },
    tipo: {
      apreciacao_risco: 'Apreciação de Risco',
      projeto_eletrico: 'Projeto Elétrico',
      diagrama_pneumatico: 'Diagrama Pneumático',
      manual_operacao: 'Manual de Operação',
      laudo_nr12: 'Laudo NR-12',
      certificado_componentes: 'Certificado de Componentes',
      plano_adequacao: 'Plano de Adequação',
      relatorio_fotografico: 'Relatório Fotográfico',
      ficha_tecnica: 'Ficha Técnica',
      checklist_seguranca: 'Checklist de Segurança',
    },
    status: {
      pendente: 'Pendente',
      em_analise: 'Em análise',
      entregue: 'Entregue',
    },
    atrasado: 'Atrasado',
    semEmissao: '—',
    modal: {
      titulo: 'Adicionar documento',
      subtitulo: 'Documento vinculado a {{maquina}}',
      tipo: 'Tipo de documento',
      codigo: 'Código',
      codigoPlaceholder: 'Ex.: PE-1042',
      revisao: 'Revisão',
      responsavel: 'Responsável',
      responsavelPlaceholder: 'Quem responde pelo documento',
      prazo: 'Prazo de entrega',
      status: 'Situação',
      arquivo: 'Arquivo',
      observacao: 'Observação',
      observacaoPlaceholder: 'Contexto, pendência combinada, referência...',
      erroCodigo: 'Informe o código do documento.',
      adicionado: 'Documento adicionado a esta máquina.',
      removido: 'Documento removido.',
    },
    acao: {
      remover: 'Remover documento',
      marcarEntregue: 'Marcar como entregue',
      marcarPendente: 'Marcar como pendente',
    },
    filtro: {
      documentoPendente: 'Documento pendente',
      documentoPendenteTodos: 'Qualquer tipo',
      situacao: 'Situação documental',
      situacaoTodas: 'Todas',
      situacaoComPendencia: 'Com pendência',
      situacaoSemPendencia: 'Sem pendência',
      situacaoAtrasado: 'Com atraso',
      aviso: 'Filtro de documentos aplicado sobre a página atual (prévia).',
    },
    colunaDashboard: 'Documentos',
    resumoLinha: {
      emDia: 'Em dia',
      pendentes: '{{total}} pendente(s)',
      atrasados: '{{total}} em atraso',
    },
  },
  en: {
    painel: {
      titulo: 'Machine documents',
      subtitulo: 'Document set required for this equipment',
      previa: 'preview',
      previaExplicacao: 'Prototype module: documents stay in this browser and are not sent to the server yet.',
      adicionar: 'Add document',
      vazio: 'No documents on this equipment yet.',
      contagem: '{{total}} document(s)',
    },
    resumo: {
      pendentes: 'Pending',
      emAnalise: 'Under review',
      entregues: 'Delivered',
      atrasados: 'Overdue',
    },
    coluna: {
      tipo: 'Type',
      codigo: 'Code',
      revisao: 'Rev.',
      responsavel: 'Owner',
      emissao: 'Issued',
      prazo: 'Due date',
    },
    tipo: {
      apreciacao_risco: 'Risk Assessment',
      projeto_eletrico: 'Electrical Drawing',
      diagrama_pneumatico: 'Pneumatic Diagram',
      manual_operacao: 'Operation Manual',
      laudo_nr12: 'NR-12 Report',
      certificado_componentes: 'Component Certificate',
      plano_adequacao: 'Compliance Plan',
      relatorio_fotografico: 'Photo Report',
      ficha_tecnica: 'Data Sheet',
      checklist_seguranca: 'Safety Checklist',
    },
    status: {
      pendente: 'Pending',
      em_analise: 'Under review',
      entregue: 'Delivered',
    },
    atrasado: 'Overdue',
    semEmissao: '—',
    modal: {
      titulo: 'Add document',
      subtitulo: 'Document linked to {{maquina}}',
      tipo: 'Document type',
      codigo: 'Code',
      codigoPlaceholder: 'e.g.: PE-1042',
      revisao: 'Revision',
      responsavel: 'Owner',
      responsavelPlaceholder: 'Who answers for this document',
      prazo: 'Due date',
      status: 'Status',
      arquivo: 'File',
      observacao: 'Notes',
      observacaoPlaceholder: 'Context, agreed pending item, reference...',
      erroCodigo: 'Enter the document code.',
      adicionado: 'Document added to this machine.',
      removido: 'Document removed.',
    },
    acao: {
      remover: 'Remove document',
      marcarEntregue: 'Mark as delivered',
      marcarPendente: 'Mark as pending',
    },
    filtro: {
      documentoPendente: 'Pending document',
      documentoPendenteTodos: 'Any type',
      situacao: 'Document status',
      situacaoTodas: 'All',
      situacaoComPendencia: 'With pending items',
      situacaoSemPendencia: 'No pending items',
      situacaoAtrasado: 'Overdue',
      aviso: 'Document filter applied to the current page (preview).',
    },
    colunaDashboard: 'Documents',
    resumoLinha: {
      emDia: 'Up to date',
      pendentes: '{{total}} pending',
      atrasados: '{{total}} overdue',
    },
  },
};
